import { defaultAxios } from '@/services';

export type VerifyOktaPayload = {
  readonly accessToken: string;
};

export type VerifyOktaResponse = {
  user_id: string;
  first_name: string;
  last_name: string;
  email: string;
  has_workspace: boolean;
  color: number;
};

export async function verifyOkta(payload: VerifyOktaPayload) {
  const response = await defaultAxios.post<VerifyOktaResponse>(
    '/auth/verify?vendor_type=okta',
    {
      oauth_token: payload.accessToken,
    },
  );

  return response.data;
}
